import { create } from 'zustand';
import { ContentsApiResponseResultsType } from '~/searchApi';

import { AddContentStore } from './ModalAddContent/types';

export const useAddContentStore = create<AddContentStore>((set) => ({
  isModalOpen: false,
  isCustomModalOpen: false,
  isContentDetailModalOpen: false,

  isEditMode: false,
  creatorId: undefined,
  contentId: undefined,
  blockId: undefined,
  filters: [],
  platforms: '',
  platformOptions: [],
  sortBy: 'published_at',
  postedBy: 0,
  searchQuery: '',
  page: 1,
  selectedContent: [],
  modifiedContents: null,
  showInShared: false,

  callback: undefined,

  setIsModalOpen: (isModalOpen, id, callback) =>
    set(() => {
      return { isModalOpen, creatorId: id, callback };
    }),

  setIsCustomModalOpen: (isCustomModalOpen) =>
    set(() => {
      return { isCustomModalOpen };
    }),

  setIsContentDetailModalOpen: (isContentDetailModalOpen, contentId) =>
    set(() => {
      return { isContentDetailModalOpen, contentId };
    }),

  setIsEditMode: (isEditMode, blockId) =>
    set(() => {
      return { isEditMode, blockId: blockId };
    }),

  setFilters: (newFilter) =>
    set((state) => {
      const filterExists = state.filters.some(
        (filter) =>
          filter.name === newFilter.name &&
          filter.comparator === newFilter.comparator,
      );

      return {
        filters: filterExists
          ? state.filters.map((filter) =>
              filter.name === newFilter.name &&
              filter.comparator === newFilter.comparator
                ? { ...filter, ...newFilter }
                : filter,
            )
          : [...state.filters, newFilter],
      };
    }),

  removeFilter: (filterName) =>
    set((state) => ({
      filters: state.filters.filter((filter) => filter.name !== filterName),
    })),

  setPlatforms: (platforms) =>
    set(() => {
      return {
        platforms: platforms,
      };
    }),

  setPlatformOptions: (options) =>
    set(() => {
      return {
        platformOptions: options,
      };
    }),

  clearPlatformsAndOptions: () =>
    set((state) => {
      state.removeFilter('product_type');
      return {
        platforms: '',
        platformOptions: [],
      };
    }),

  setSortBy: (sortBy) => set({ sortBy }),
  setPostedBy: (postedBy) => set({ postedBy }),
  resetPostedBy: () => set({ postedBy: 0 }),
  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setPage: (page) => set({ page }),

  setSelectedContent: (content: ContentsApiResponseResultsType[]) =>
    set({ selectedContent: content }),

  setModifiedContents: (content: ContentsApiResponseResultsType[] | null) =>
    set({ modifiedContents: content }),

  setShowInShared: (showInShared) => set({ showInShared }),

  reset: () =>
    set(() => {
      return {
        isModalOpen: false,
        isEditMode: false,
        isContentDetailModalOpen: false,
        creatorId: undefined,
        contentId: undefined,
        filters: [],
        platforms: '',
        platformOptions: [],
        sortBy: 'published_at',
        postedBy: 0,
        searchQuery: '',
        page: 1,
        selectedContent: [],
        modifiedContents: null,
        callback: undefined,
      };
    }),
}));
